import React from 'react';
import PointIcon from '../../../../assets/point-icon.svg';

export default function PointsCard({ earnedPoints, givenPoints, readers, writers }) {
  const formatPlural = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

  return (
    <div className="flex flex-col flex-wrap gap-1">
      <div className="flex items-center space-x-1 text-xs text-growth-green-900 font-[800] whitespace-nowrap">
        <img className="w-4 h-4 md:w-5 md:h-5" src={PointIcon} alt="" />
        <span className="text-xs md:text-sm">{earnedPoints || 0} Earned Twigs</span>
        <span className="text-xs md:text-sm font-[400]">
          • {formatPlural(readers, 'Reader', 'Readers') || 0}
        </span>
      </div>
      <div className="flex items-center space-x-1 text-growth-green-900 font-[800] whitespace-nowrap">
        <img className="w-4 h-4 md:w-5 md:h-5" src={PointIcon} alt="" />
        <span className="text-xs md:text-sm">{givenPoints || 0} Given Twigs</span>
        <span className="text-xs md:text-sm font-[400]">
          • {formatPlural(writers, 'Writer', 'Writers') || 0}
        </span>
      </div>
    </div>
  );
}
